import request from '@/axios'
import type { LoginReq, RegisterReq, SendSmsReq, UserInfo } from './types'

/**
 * 对认证中心 API 发起请求
 * Dev 模式走 Vite 代理（相对路径），Prod/Test 直连 AuthCenter
 */
const AUTH_BASE = import.meta.env.VITE_AUTH_API_BASE || ''

const authRequest = {
  get: (config: { url: string; params?: any }) =>
    request.get({ url: AUTH_BASE + config.url, params: config.params }),
  post: (config: { url: string; params?: any; data?: any }) =>
    request.post({ url: AUTH_BASE + config.url, params: config.params, data: config.data }),
}

// ========== 认证相关（已迁移至 AuthCenter /Auth 路由） ==========

/**
 * 发送短信验证码
 * GET /TextMessage（Query 传参）
 */
export const sendSmsCodeApi = (data: SendSmsReq): Promise<IResponse<null>> => {
  return authRequest.get({ url: '/TextMessage', params: data })
}

/**
 * 用户登录
 * POST /Login（Form 传参）
 */
export const loginApi = (data: LoginReq): Promise<IResponse<{ token: string; userInfo: UserInfo; refresh_token?: string }>> => {
  return request.post({
    url: AUTH_BASE + '/Login',
    data: { UserName: data.UserName, Password: data.pwd, RememberMe: 'false' },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}

/**
 * 用户注册
 * POST /Register（Body JSON，code 一并放在 body 中）
 */
export const registerApi = (data: RegisterReq): Promise<IResponse<null>> => {
  return authRequest.post({ url: '/Register', data })
}

// ========== 用户信息相关（仍在 FrontEndPlatformAPI） ==========

/**
 * 获取当前用户个人资料及统计
 * GET /User/User/GetProfile
 */
export const getProfileApi = (): Promise<IResponse<UserInfo>> => {
  return request.get({ url: '/User/User/GetProfile' })
}

/**
 * 根据 ID 获取用户信息
 * GET /User/User/GetByID
 */
export const getUserByIdApi = (id: string): Promise<IResponse<UserInfo>> => {
  return request.get({ url: '/User/User/GetByID', params: { ID: id } })
}

/**
 * 更新个人资料
 * POST /User/User/UpdateProfile
 */
export const updateProfileApi = (data: Partial<UserInfo>): Promise<IResponse<null>> => {
  return request.post({ url: '/User/User/UpdateProfile', data })
}

/**
 * 忘记密码 - 通过短信验证码重置密码
 * POST /ForgotPassword
 */
export const forgotPasswordApi = (phone: string, code: string, newPassword: string): Promise<IResponse<null>> => {
  return authRequest.post({
    url: '/ForgotPassword',
    params: { Phone: phone, Code: code, newPassword },
  })
}

/**
 * 修改密码
 * POST /ChangePassword
 */
export const changePasswordApi = (id: string, oldPassword: string, newPassword: string, code: string): Promise<IResponse<null>> => {
  return authRequest.post({
    url: '/ChangePassword',
    params: { ID: id, OldPassword: oldPassword, newPassword: newPassword, Code: code },
  })
}

/**
 * 更新头像
 * POST /User/User/UpdateAvatar
 */
export const updateAvatarApi = (headImg: string): Promise<IResponse<null>> => {
  return request.post({ url: '/User/User/UpdateAvatar', params: { HeadImg: headImg } })
}
